import { render, staticRenderFns } from "./CommandsList.vue?vue&type=template&id=5820e918&"
import script from "./CommandsList.vue?vue&type=script&lang=js&"
export * from "./CommandsList.vue?vue&type=script&lang=js&"
import style0 from "./CommandsList.vue?vue&type=style&index=0&id=5820e918&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports